__turbopack_context__.v({
  "aboutCopy": "marketing-home-module__q7Au8W__aboutCopy",
  "aboutGrid": "marketing-home-module__q7Au8W__aboutGrid",
  "aboutInner": "marketing-home-module__q7Au8W__aboutInner",
  "aboutPillars": "marketing-home-module__q7Au8W__aboutPillars",
  "aboutSection": "marketing-home-module__q7Au8W__aboutSection",
  "activeNavItem": "marketing-home-module__q7Au8W__activeNavItem",
  "anchorTarget": "marketing-home-module__q7Au8W__anchorTarget",
  "badge": "marketing-home-module__q7Au8W__badge",
  "benefits": "marketing-home-module__q7Au8W__benefits",
  "brand": "marketing-home-module__q7Au8W__brand",
  "browserBar": "marketing-home-module__q7Au8W__browserBar",
  "builder": "marketing-home-module__q7Au8W__builder",
  "checked": "marketing-home-module__q7Au8W__checked",
  "completion": "marketing-home-module__q7Au8W__completion",
  "copyright": "marketing-home-module__q7Au8W__copyright",
  "ctas": "marketing-home-module__q7Au8W__ctas",
  "description": "marketing-home-module__q7Au8W__description",
  "downloadButton": "marketing-home-module__q7Au8W__downloadButton",
  "featureCard": "marketing-home-module__q7Au8W__featureCard",
  "featureGrid": "marketing-home-module__q7Au8W__featureGrid",
  "featureIcon": "marketing-home-module__q7Au8W__featureIcon",
  "featureMeta": "marketing-home-module__q7Au8W__featureMeta",
  "featureNumber": "marketing-home-module__q7Au8W__featureNumber",
  "featuresEyebrow": "marketing-home-module__q7Au8W__featuresEyebrow",
  "featuresInner": "marketing-home-module__q7Au8W__featuresInner",
  "featuresSection": "marketing-home-module__q7Au8W__featuresSection",
  "fieldHeading": "marketing-home-module__q7Au8W__fieldHeading",
  "footer": "marketing-home-module__q7Au8W__footer",
  "footerBrand": "marketing-home-module__q7Au8W__footerBrand",
  "footerContact": "marketing-home-module__q7Au8W__footerContact",
  "footerContactIcon": "marketing-home-module__q7Au8W__footerContactIcon",
  "footerContactIcons": "marketing-home-module__q7Au8W__footerContactIcons",
  "footerGroup": "marketing-home-module__q7Au8W__footerGroup",
  "footerInner": "marketing-home-module__q7Au8W__footerInner",
  "header": "marketing-home-module__q7Au8W__header",
  "headerCta": "marketing-home-module__q7Au8W__headerCta",
  "hero": "marketing-home-module__q7Au8W__hero",
  "heroCopy": "marketing-home-module__q7Au8W__heroCopy",
  "heroInner": "marketing-home-module__q7Au8W__heroInner",
  "hosting": "marketing-home-module__q7Au8W__hosting",
  "jobField": "marketing-home-module__q7Au8W__jobField",
  "jobSeekerHeading": "marketing-home-module__q7Au8W__jobSeekerHeading",
  "jobSeekerInner": "marketing-home-module__q7Au8W__jobSeekerInner",
  "jobSeekerNote": "marketing-home-module__q7Au8W__jobSeekerNote",
  "jobSeekerSection": "marketing-home-module__q7Au8W__jobSeekerSection",
  "jobSeekerSteps": "marketing-home-module__q7Au8W__jobSeekerSteps",
  "localeSwitch": "marketing-home-module__q7Au8W__localeSwitch",
  "logo": "marketing-home-module__q7Au8W__logo",
  "miniCtaAction": "marketing-home-module__q7Au8W__miniCtaAction",
  "miniCtaBox": "marketing-home-module__q7Au8W__miniCtaBox",
  "miniCtaSection": "marketing-home-module__q7Au8W__miniCtaSection",
  "mockup": "marketing-home-module__q7Au8W__mockup",
  "mockupFooter": "marketing-home-module__q7Au8W__mockupFooter",
  "nav": "marketing-home-module__q7Au8W__nav",
  "navActions": "marketing-home-module__q7Au8W__navActions",
  "navLinks": "marketing-home-module__q7Au8W__navLinks",
  "orgBanner": "marketing-home-module__q7Au8W__orgBanner",
  "orgBannerAction": "marketing-home-module__q7Au8W__orgBannerAction",
  "orgBannerInner": "marketing-home-module__q7Au8W__orgBannerInner",
  "orgBannerText": "marketing-home-module__q7Au8W__orgBannerText",
  "page": "marketing-home-module__q7Au8W__page",
  "previewIcon": "marketing-home-module__q7Au8W__previewIcon",
  "pricingOption": "marketing-home-module__q7Au8W__pricingOption",
  "pricingTeaser": "marketing-home-module__q7Au8W__pricingTeaser",
  "pricingTeaserInner": "marketing-home-module__q7Au8W__pricingTeaserInner",
  "pricingTeaserLink": "marketing-home-module__q7Au8W__pricingTeaserLink",
  "primaryCta": "marketing-home-module__q7Au8W__primaryCta",
  "resumePreviewEntry": "marketing-home-module__q7Au8W__resumePreviewEntry",
  "resumePreviewMeta": "marketing-home-module__q7Au8W__resumePreviewMeta",
  "resumePreviewSection": "marketing-home-module__q7Au8W__resumePreviewSection",
  "secondaryCta": "marketing-home-module__q7Au8W__secondaryCta",
  "sidebar": "marketing-home-module__q7Au8W__sidebar",
  "sidebarLabel": "marketing-home-module__q7Au8W__sidebarLabel",
  "suggestion": "marketing-home-module__q7Au8W__suggestion",
  "suggestions": "marketing-home-module__q7Au8W__suggestions",
  "summaryCard": "marketing-home-module__q7Au8W__summaryCard",
  "summaryCards": "marketing-home-module__q7Au8W__summaryCards",
  "workspace": "marketing-home-module__q7Au8W__workspace",
});
